import { SceneKeys } from '../SceneKeys';
import { BaseScene } from './BaseScene';

export class BootScene extends BaseScene {
    pauseGame(): void {
        // throw new Error('Method not implemented.');
    }
    resumeGame(): void {
        // throw new Error('Method not implemented.');
    }

    constructor() {
        super("BootScene");
    }

    preload() {
        //Load preloader assets here..
    }

    async create() {

        const c = await import('./Preloader');
        this.scene.add(SceneKeys.PRELOADER, c.PreloaderScene, false);
        this.scene.start(SceneKeys.PRELOADER);

    }

}